import { apiIos } from './http'

let adminGeneral={
	login:{
		desc: '登录',
		http:p => apiIos({type:'post',name:'login',action:'2000000'}, p)
	},
	wxLogin:{
		desc: '微信授权登录',
		http:p => apiIos({type:'post',name:'wxLogin',action:'2000099'}, p)
	},
	codeLogin:{
		desc: '验证码登录',
		http:p => apiIos({type:'post',name:'codeLogin',action:'2000016'}, p)
	},
	modifyPassword:{
		desc: '修改密码',
		http:p => apiIos({type:'post',name:'modifyPassword',action:'2000018'}, p)
	},
	registered:{
		desc: '注册',
		http:p => apiIos({type:'post',name:'registered',action:'2000004'}, p)
	},
	registeredCy:{
		desc: '邀请码注册',
		http:p => apiIos({type:'post',name:'registeredCy',action:'2000037'}, p)
	},
	mobileCode:{
		desc: '获取验证码',
		http:p => apiIos({type:'post',name:'mobileCode',action:'3004001'}, p)
	},
	codeQueryCompany:{
		desc: '邀请码查询公司',
		http:p => apiIos({type:'post',name:'codeQueryCompany',action:'2000097'}, p)
	},
	joinCompany:{
		desc: '加入公司',
		http:p => apiIos({type:'post',name:'joinCompany',action:'2000102'}, p)
	},
	userInfo:{
		desc: '用户信息',
		http:p => apiIos({type:'post',name:'userInfo',action:'2000029'}, p)
	},
	setuserInfo:{
		desc: '修改用户信息',
		http:p => apiIos({type:'post',name:'setuserInfo',action:'2000002'}, p)
	},
	shakeHands:{
		desc: '用户握手',
		http:p => apiIos({type:'post',name:'shakeHands',action:'2000015'}, p)
	},
	userProductList:{
		desc: '用户获取公司已授权产品列表',
		http:p => apiIos({type:'post',name:'userProductList',action:'2001009'}, p)
	},
	userInformationTypeList:{
		desc: '获取用户信息类型列表',
		http:p => apiIos({type:'post',name:'userInformationTypeList',action:'2001304'}, p)
	},
	activityList:{
		desc: '获取活动列表',
		http:p => apiIos({type:'post',name:'activityList',action:'2001707'}, p)
	},
	userVoteList:{
		desc: '用户获取投票列表',
		http:p => apiIos({type:'post',name:'userVoteList',action:'2001430'}, p)
	},
	userSurveyList:{
		desc: '用户获取调查列表',
		http:p => apiIos({type:'post',name:'userSurveyList',action:'2001530'}, p)
	},
	toViewList:{
		desc: '获取查看列表',
		http:p => apiIos({type:'post',name:'toViewList',action:'2001319'}, p)
	},
	getDepartmentList: {
		desc: '获取部门列表',
		http:p => apiIos({type:'post',name:'getDepartmentList',action:'2000023'}, p)
	},
	handleBeforeUpload: {
		desc: '上传',
		http:p => apiIos({type:'post',name:'handleBeforeUpload',action:'3001321'}, p)
	},
	jssdkSignature: {
		desc: '自定义分享',
		http:p => apiIos({type:'post',name:'jssdkSignature',action:'2000096'}, p)
	},
	department: {
		desc: '用户是否存在部门中',
		http:p => apiIos({type:'post',name:'department',action:'2000028'}, p)
	},
}
/*畅阅*/
let changYueAcions = {
	listenSingle:{
		desc: '设置听单状态',
		http:p => apiIos({type:'post',name:'listenSingle',action:'2001929'}, p)
	},
	userStatistical:{
		desc: '按用户数据统计',
		http:p => apiIos({type:'post',name:'userStatistical',action:'2001032'}, p)
	},
	manuscriptStatistical:{
		desc: '按稿件数据统计',
		http:p => apiIos({type:'post',name:'manuscriptStatistical',action:'2001033'}, p)
	},
	commentsDataAll:{
		desc: '统计总评论数',
		http:p => apiIos({type:'post',name:'commentsDataAll',action:'2001036'}, p)
	},
	getTheArticle:{
		desc: '派单',
		http:p => apiIos({type:'post',name:'getTheArticle',action:'2001928'}, p)
	},
	getManuscriptList:{
		desc: '稿件列表',
		http:p => apiIos({type:'post',name:'getManuscriptList',action:'2001923'}, p)
	},
	getCommentsList:{
		desc: '稿件评论列表',
		http:p => apiIos({type:'post',name:'getCommentsList',action:'2001024'}, p)
	},
	commentsSubmint:{
		desc: '提交评论',
		http:p => apiIos({type:'post',name:'commentsSubmint',action:'2001021'}, p)
	},
	getMaxAndMin:{
		desc: '取稿件是按最小值取还是最大值取',
		http:p => apiIos({type:'post',name:'getMaxAndMin',action:'2001037'}, p)
	},
	delComments:{
		desc: '删除评论',
		http:p => apiIos({type:'post',name:'delComments',action:'2001022'}, p)
	},
	getRecommentNums:{
		desc: '获取某个用户可用自荐优评数量',
		http:p => apiIos({type:'post',name:'getRecommentNums',action:'2001065'}, p)
	}
}
/*活动聚*/
let huoDongJuAcions = {
	getFormList:{
		desc: '客户端获取表单列表(可不登陆)',
		http:p => apiIos({type:'post',name:'getFormList',action:'2002205'}, p)
	},
	getVoteFormList:{
		desc: '用户获取投票问题列表(可不登陆)',
		http:p => apiIos({type:'post',name:'getVoteFormList',action:'2001431'}, p)
	},
	getActivityDetail:{
		desc: '获取活动详情(可不登陆)',
		http:p => apiIos({type:'post',name:'getActivityDetail',action:'2001713'}, p)
	},
	activityFormSubmit:{
		desc: '提交活动报名(可不登陆)',
		http:p => apiIos({type:'post',name:'activityFormSubmit',action:'2001708'}, p)
	},
	getActivitusereport:{
		desc: '用户报名情况',
		http:p => apiIos({type:'post',name:'getActivitusereport',action:'2001716'}, p)
	},
	getCascader:{
		desc: '获取省份',
		http:p => apiIos({type:'post',name:'getCascader',action:'2001931'}, p)
	},
	voteSubmit:{
		desc: '投票提交',
		http:p => apiIos({type:'post',name:'voteSubmit',action:'2001432'}, p)
	},
	getformstatus:{
		desc: '获取提交状态',
		http:p => apiIos({type:'post',name:'getformstatus',action:'2001514'}, p)
	},
	getUsereport:{
		desc: '查看提交情况',
		http:p => apiIos({type:'post',name:'getUsereport',action:'2001534'}, p)
	},
	formSubmitSave:{
		desc: '客户端提交表单(可不登陆)',
		http:p => apiIos({type:'post',name:'formSubmitSave',action:'2002206'}, p)
	},
	getFormDetail:{
		desc: '获取简易表单详情',
		http:p => apiIos({type:'post',name:'getFormDetail',action:'2002208'}, p)
	},
	getSurveyDetail:{
		desc: '获取调查详情（可不登陆）',
		http:p => apiIos({type:'post',name:'surveyDetail',action:'2001531'}, p)
	},
	getSurveyList:{
		desc: '获取调查列表（可不登陆）',
		http:p => apiIos({type:'post',name:'getSurveyList',action:'2001530'}, p)
	},
	surveySubmit:{
		desc: '用户提交调查结果(可不登陆)',
		http:p => apiIos({type:'post',name:'surveySubmit',action:'2001532'}, p)
	},
	getVoteList:{
		desc: '用户获取投票列表(可不登陆)',
		http:p => apiIos({type:'post',name:'getVoteList',action:'2001430'}, p)
	},
}
/*资讯*/
let infomanager = {
	detailInfo:{
		desc: '文章详情',
		http:p => apiIos({type:'post',name:'detailInfo',action:'2001320'}, p)
	},
}
var apiActions =   /*#__PURE__*/{
	infomanager,
	changYueAcions,
	adminGeneral,
	huoDongJuAcions
}

export  default apiActions;